import { mediaUrl } from '../lib/api';

export const MQ_MOBILE = '(max-width: 767px)';

const ResponsiveImg = ({ desktop, mobile, alt = '', className = '', fill = false, ...rest }) => {
  const d = mediaUrl(String(desktop || '').trim());
  const m = mediaUrl(String(mobile || '').trim());
  const src = d || m;
  if (!src) return null;

  if (fill) {
    const both = Boolean(m && d && m !== d);
    return (
      <>
        {both ? (
          <>
            <img src={m} alt={alt} className="ri-fill ri-only-mobile" {...rest} />
            <img src={d} alt={alt} className="ri-fill ri-only-desktop" {...rest} />
          </>
        ) : (
          <img src={src} alt={alt} className="ri-fill" {...rest} />
        )}
      </>
    );
  }

  if (m && d && m !== d) {
    return (
      <span className="inline-block max-w-full">
        <img src={d} alt={alt} className={`ri-only-desktop ${className}`.trim()} {...rest} />
        <img src={m} alt={alt} className={`ri-only-mobile ${className}`.trim()} {...rest} />
      </span>
    );
  }
  return <img src={src} alt={alt} className={className} {...rest} />;
};

export default ResponsiveImg;
